import React, { createContext, useContext } from 'react';

interface ITextInputActionProps {
  id: string;
  children: React.ReactNode;
  isValid?: boolean;
  isInvalid?: boolean;
  UNSAFE_className?: string;
  isLoading?: boolean;
}

type TTextInputActionContext = Omit<ITextInputActionProps, 'children'>;

const TextInputActionContext = createContext<TTextInputActionContext>({
  id: '',
  isValid: false,
  isInvalid: false,
  UNSAFE_className: '',
  isLoading: false,
});

export const useTextInputAction = () =>
  useContext<TTextInputActionContext>(TextInputActionContext);

const TextInputAction: React.FC<ITextInputActionProps> = ({
  id,
  children,
  isValid,
  isInvalid,
  isLoading,
  UNSAFE_className = '',
}) => {
  return (
    <TextInputActionContext.Provider
      value={{ id, isValid, isInvalid, isLoading }}
    >
      <div
        className={`${UNSAFE_className} text-input-action tw-group tw-group tw-relative tw-grid !tw-grid-cols-[auto_min-content] tw-grid-template-[input_button|text_text] [&:has(input:disabled)]:tw-lf-input-disabled`}
      >
        {children}
      </div>
    </TextInputActionContext.Provider>
  );
};

export default TextInputAction;
